(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bb-areviews-presentation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bb-areviews-presentation')) {
    customElements.define('bb-areviews-presentation', class extends HTMLElement {
      connectedCallback() {
        this.rootSelector = '.areviews_modalz, .AreviewsHeader5-activeFilters';
        this.observer = new MutationObserver(records => {
          const relevant = records.some(record => {
            const target = record.target.nodeType === Node.ELEMENT_NODE ? record.target : record.target.parentElement;
            if (target?.closest(this.rootSelector)) return true;
            return Array.from(record.addedNodes).some(node =>
              node.nodeType === Node.ELEMENT_NODE &&
              (node.matches(this.rootSelector) || node.querySelector(this.rootSelector))
            );
          });
          if (relevant) this.scheduleUpdate();
        });
        this.observer.observe(document.body, { childList: true, subtree: true, characterData: true });
        this.updateInterface();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
      }

      scheduleUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          if (this.isConnected) this.updateInterface();
        });
      }

      updateInterface() {
        const text = this.dataset;
        document.querySelectorAll('.areviews_modalz').forEach(modal => {
          const title = modal.querySelector('.areviews_modalz-title');
          if (title?.textContent.trim() === 'Media Gallery' && title.textContent !== text.galleryTitle) {
            title.textContent = text.galleryTitle;
          }
          const pagination = modal.querySelector('.areviews_modalz-pagination');
          const range = pagination?.textContent.trim().match(/^Showing\s+([\d.,]+)\s*[-–]\s*([\d.,]+)\s+of\s+([\d.,]+)\s+items?$/i);
          if (range) {
            const translated = text.galleryRange.replace('[first]', range[1]).replace('[last]', range[2]).replace('[total]', range[3]);
            if (pagination.textContent !== translated) pagination.textContent = translated;
          }
          modal.querySelector('.areviews_modalz-close')?.setAttribute('aria-label', text.close);
          modal.querySelectorAll('.areviews_modalz-nav-arrow').forEach(button => {
            button.setAttribute('aria-label', button.classList.contains('prev-page') ? text.previous : text.next);
            button.setAttribute('aria-disabled', String(button.classList.contains('disabled')));
          });
          modal.querySelectorAll('img[alt="Media content"]').forEach(img => img.alt = text.mediaAlt);
        });
        document.querySelectorAll('.AreviewsHeader5-activeFilters').forEach(filters => {
          const label = filters.querySelector('#activeFilterLabel');
          if (!label) return;
          const nodes = Array.from(label.childNodes).filter(node => node.nodeType === Node.TEXT_NODE);
          const value = nodes.map(node => node.textContent).join('').trim();
          const empty = /^(none|nenhum|nenhum filtro)?$/i.test(value);
          filters.dataset.bbEmpty = String(empty);
          if (empty) {
            nodes.forEach(node => {
              if (/^\s*None\s*$/i.test(node.textContent) && node.textContent !== text.noFilters) node.textContent = text.noFilters;
            });
          } else {
            nodes.forEach(node => {
              const rating = node.textContent.match(/(?:^|:\s*)([1-5])\s+Star Ratings?\s*$/i);
              if (rating) node.textContent = `${rating[1]} ${rating[1] === '1' ? text.star : text.stars} `;
            });
          }
          filters.querySelectorAll('.AreviewsHeader5-clearFilter').forEach(button => button.setAttribute('aria-label', text.clear));
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bb-product-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bb-product-price')) {
    customElements.define('bb-product-price', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.form = document.forms.namedItem(this.getAttribute('form'));
        this.money = new Intl.NumberFormat(this.dataset.locale || 'pt-BR', {style:'currency',currency:this.dataset.currency || 'BRL'});
        this.form?.addEventListener('variant:change', (event) => this.update(event.detail.variant), {signal:this.controller.signal});
      }
      disconnectedCallback() { this.controller.abort(); }
      update(variant) {
        this.hidden = !variant;
        if (!variant) return;
        const compare = Number(variant.compare_at_price) || 0;
        const price = Number(variant.price);
        const money = (cents) => this.money.format(cents / 100);
        this.querySelector('[data-pix]').textContent = money(Math.round(price * (100-Number(this.dataset.pixPercent))/100));
        this.querySelector('[data-compare]').hidden = compare <= price;
        this.querySelector('[data-compare]').textContent = money(compare);
        const discount = compare > price ? Math.round((compare - price) * 100 / compare) : 0;
        this.querySelector('[data-discount]').hidden = discount <= 0;
        this.querySelector('[data-discount]').textContent = `-${discount}%`;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bb-vip-gate"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('bb-vip-gate'))customElements.define('bb-vip-gate',class extends HTMLElement{
    connectedCallback(){
      this.onDocumentReady=()=>this.connect();
      if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',this.onDocumentReady,{once:true});
      else this.connect();
    }
    connect(){
      const initialize=()=>{
        if(!this.querySelector('dialog [data-gate-form]')||!this.querySelector('[data-gate-open]'))return false;
        this.observer?.disconnect();this.initialize();return true;
      };
      if(!initialize()){this.observer=new MutationObserver(initialize);this.observer.observe(this,{childList:true,subtree:true});}
    }
    initialize(){
      if(this.controller)return;
      this.controller=new AbortController();const options={signal:this.controller.signal};
      this.editor=this.hasAttribute('data-editor');this.dialog=this.querySelector('dialog');this.form=this.dialog.querySelector('[data-gate-form]');this.error=this.dialog.querySelector('[data-gate-error]');this.input=this.form.elements.vip_password;
      const hours=Number(this.dataset.remember);this.rememberHours=Number.isFinite(hours)?Math.max(0,Math.min(24,hours)):4;
      const scope=this.hasAttribute('data-global')?'store':location.pathname;
      this.key=`bb-vip:v3:${scope}:${this.dataset.campaign}:${this.dataset.hash}:${this.dataset.start}:${this.dataset.end}:${this.rememberHours}`;
      this.main=this.closest('main')||document.getElementById('main')||document.querySelector('main');this.targets=this.editor?[]:[...(this.main?.children||[])].filter(el=>!el.contains(this)).map(el=>({el,inert:el.inert}));
      this.form.addEventListener('submit',event=>this.submit(event),options);
      this.input.addEventListener('input',()=>{this.error.hidden=true;this.input.removeAttribute('aria-invalid');},options);
      this.querySelector('[data-gate-open]').addEventListener('click',()=>this.open(),options);
      this.dialog.querySelectorAll('[data-gate-close]').forEach(button=>button.addEventListener('click',()=>this.dialog.close(),options));
      this.dialog.addEventListener('close',()=>document.body.classList.remove('bb-vip-locked'),options);
      if(this.editor){
        const panel=this.querySelector('[data-gate-editor-panel]');
        if(panel){for(const name of ['shopify:section:select','shopify:section:deselect'])document.addEventListener(name,event=>{if(event.target.contains(this))panel.open=name==='shopify:section:select';},options);}
        this.checkWindow();return;
      }
      window.addEventListener('pageshow',event=>{if(event.persisted){if(this.rememberHours===0)this.unlockedForPage=false;this.input.value='';this.error.hidden=true;this.checkWindow();}},{signal:this.controller.signal});
      this.timer=setInterval(()=>this.checkWindow(),30000);
      if(this.windowState()==='open'&&this.remembered()){this.unlock(false);return;}
      this.hidden=false;this.setAttribute('data-locked','');this.targets.forEach(({el})=>el.inert=true);this.checkWindow();this.open();
    }
    windowState(){
      if(this.hasAttribute('data-unconfigured'))return 'configure';
      const parse=value=>value?Date.parse(value):null,start=parse(this.dataset.start),end=parse(this.dataset.end),now=Date.now();
      if(Number.isNaN(start)||Number.isNaN(end)||(start!==null&&end!==null&&end<=start))return 'unavailable';
      if(start!==null&&now<start)return 'notOpen';if(end!==null&&now>=end)return 'closed';return 'open';
    }
    remembered(){if(this.rememberHours===0)return this.unlockedForPage===true;if(this.sessionExpires>Date.now())return true;try{return Number(sessionStorage.getItem(this.key))>Date.now();}catch{return false;}}
    checkWindow(){
      const state=this.windowState(),status=this.dialog.querySelector('[data-gate-status]');
      status.hidden=state==='open';status.textContent=state==='open'?'':this.dataset[state];this.form.hidden=state!=='open';
      if(this.editor)return;
      if(!this.hasAttribute('data-locked')&&(state!=='open'||!this.remembered())){this.hidden=false;this.setAttribute('data-locked','');this.targets.forEach(({el})=>el.inert=true);this.open();}
    }
    open(){this.checkWindow();if(!this.dialog.open)this.dialog.showModal();document.body.classList.add('bb-vip-locked');if(!this.form.hidden)this.input.focus();}
    async submit(event){
      event.preventDefault();if(this.windowState()!=='open'){this.checkWindow();return;}
      const button=this.form.querySelector('[type=submit]');button.disabled=true;
      try{
        const hash=await crypto.subtle.digest('SHA-256',new TextEncoder().encode(this.input.value.trim()));
        const digest=[...new Uint8Array(hash)].map(value=>value.toString(16).padStart(2,'0')).join('');
        if(digest===this.dataset.hash){
          if(this.editor){this.dialog.close();this.querySelector('[data-editor-status]').textContent=this.dataset.previewSuccess;this.input.value='';}
          else this.unlock(true);
          return;
        }
        this.error.textContent=this.dataset.wrong;this.error.hidden=false;this.input.setAttribute('aria-invalid','true');this.input.focus();this.input.select();
      }catch{this.error.textContent=this.dataset.unavailable;this.error.hidden=false;}
      finally{button.disabled=false;}
    }
    unlock(save){
      if(save){
        if(this.rememberHours===0)this.unlockedForPage=true;
        else{this.sessionExpires=Date.now()+this.rememberHours*3600000;try{sessionStorage.setItem(this.key,String(this.sessionExpires));}catch{}}
      }
      this.removeAttribute('data-locked');this.hidden=true;if(this.dialog.open)this.dialog.close();document.body.classList.remove('bb-vip-locked');
      this.targets.forEach(({el,inert})=>el.inert=inert);
      if(save){const target=this.main?.querySelector('.shopify-section:not(:has(bb-vip-gate)) h1, .shopify-section:not(:has(bb-vip-gate)) h2');if(target){target.setAttribute('tabindex','-1');target.focus({preventScroll:true});}}
    }
    disconnectedCallback(){document.removeEventListener('DOMContentLoaded',this.onDocumentReady);this.observer?.disconnect();this.controller?.abort();this.controller=null;clearInterval(this.timer);if(this.dialog?.open)this.dialog.close();this.targets?.forEach(({el,inert})=>el.inert=inert);document.body.classList.remove('bb-vip-locked');}
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blocobox-whatsapp"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bb-contact-drawer')) {
    class BlocoboxContactDrawer extends HTMLElement {
      connectedCallback() {
        this.bootFrame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (this.abortController || !this.isConnected) return;
        this.trigger = this.querySelector('.bb-contact__trigger');
        this.dialog = this.querySelector('dialog');
        this.closeButton = this.querySelector('[data-close]');
        this.feedback = this.querySelector('[data-feedback]');
        if (!this.trigger || !this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.schedule = this.schedule || (() => {
          if (!this.frame && this.isConnected) {
            this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
          }
        });
        this.refreshTargets();
        this.resizeObserver = new ResizeObserver(this.schedule);
        this.watchBarSizes();
        this.observer = new MutationObserver((records) => {
          let changed = false;
          let refresh = false;
          for (const record of records) {
            if (record.target === this || this.contains(record.target)) continue;
            changed = true;
            if (record.type === 'childList') refresh = true;
          }
          if (refresh) {
            this.refreshTargets();
            this.watchBarSizes();
            this.subscribeUpcart();
          }
          if (changed) this.schedule();
        });
        this.observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'open', 'hidden', 'aria-hidden', 'inert'] });
        this.observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'style'] });
        for (const event of ['scroll', 'resize', 'pageshow', 'load']) window.addEventListener(event, this.schedule, { passive: true, signal });
        for (const event of ['focusin', 'focusout', 'transitionend']) document.addEventListener(event, this.schedule, { signal });
        document.addEventListener('variant:change', (event) => {
          if (String(event.detail?.product?.id) !== this.dataset.productId) return;
          this.currentVariantId = event.detail?.variant?.id ? String(event.detail.variant.id) : '';
          this.updateLinks();
        }, { signal });
        window.addEventListener('pagehide', () => this.closeDrawer(false), { signal });
        window.visualViewport?.addEventListener('resize', this.schedule, { passive: true, signal });
        window.visualViewport?.addEventListener('scroll', this.schedule, { passive: true, signal });
        this.trigger.addEventListener('click', () => this.openDrawer(), { signal });
        this.closeButton.addEventListener('click', () => this.closeDrawer(), { signal });
        this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.closeDrawer(); }, { signal });
        this.dialog.addEventListener('close', () => { if (!this.dialog.open) this.finishClose(false); }, { signal });
        this.dialog.addEventListener('pointerdown', (event) => { this.backdropStarted = this.isBackdropClick(event); }, { signal });
        this.dialog.addEventListener('click', (event) => {
          if (this.backdropStarted && this.isBackdropClick(event)) this.closeDrawer();
          this.backdropStarted = false;
        }, { signal });
        for (const link of this.links) link.addEventListener('click', () => this.updateLinks(), { signal });
        this.querySelectorAll('[data-copy-code]').forEach((button) => button.addEventListener('click', () => this.copyCoupon(button), { signal }));
        if (window.Shopify?.designMode) {
          const section = this.closest('.shopify-section');
          section?.addEventListener('shopify:section:select', () => this.openDrawer(), { signal });
          section?.addEventListener('shopify:section:deselect', () => this.closeDrawer(false), { signal });
          section?.addEventListener('shopify:block:select', (event) => {
            this.openDrawer();
            event.target.scrollIntoView({ block: 'nearest', behavior: 'auto' });
          }, { signal });
        }
        this.subscribeUpcart();
        if (!this.upcartSubscribed) {
          let attempts = 0;
          this.upcartTimer = setInterval(() => {
            this.subscribeUpcart();
            if (this.upcartSubscribed || ++attempts >= 60) clearInterval(this.upcartTimer);
          }, 1000);
        }
        this.update();
        if (window.Shopify?.designMode && window.bbContactEditorSection === this.dataset.sectionId) this.openDrawer();
      }

      disconnectedCallback() {
        const reopenInEditor = window.Shopify?.designMode && this.dialog?.open;
        this.closeDrawer(false);
        if (reopenInEditor) window.bbContactEditorSection = this.dataset.sectionId;
        this.abortController?.abort();
        this.abortController = null;
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        clearInterval(this.upcartTimer);
        cancelAnimationFrame(this.bootFrame);
        cancelAnimationFrame(this.frame);
        this.frame = null;
      }

      refreshTargets() {
        this.bars = [...document.querySelectorAll('product-quick-add.product-quick-add')];
        this.controls = [...document.querySelectorAll('#main button, #main input:not([type="hidden"]), #main select, #main textarea, #main a.button, #main [role="button"]')];
        this.links = [...this.querySelectorAll('[data-whatsapp-link]')];
      }

      watchBarSizes() {
        this.resizeObserver?.disconnect();
        this.bars.forEach((bar) => this.resizeObserver?.observe(bar));
      }

      subscribeUpcart() {
        if (this.upcartSubscribed || typeof window.upcartSubscribeCartOpened !== 'function' || typeof window.upcartSubscribeCartClosed !== 'function') return;
        window.upcartSubscribeCartOpened(() => {
          this.upcartOpen = true;
          if (!this.isConnected) return;
          this.closeDrawer(false);
          this.setTriggerHidden(true);
        });
        window.upcartSubscribeCartClosed(() => { this.upcartOpen = false; this.schedule(); });
        this.upcartSubscribed = true;
        clearInterval(this.upcartTimer);
      }

      updateLinks() {
        if (!/^[1-9]\d{7,14}$/.test(this.dataset.phone || '')) return;
        for (const link of this.links) {
          let message = link.dataset.message || '';
          if (this.dataset.productUrl) {
            const productUrl = new URL(this.dataset.productUrl);
            const urlVariant = new URL(window.location.href).searchParams.get('variant');
            const variant = this.currentVariantId ?? urlVariant ?? this.dataset.variantId;
            if (variant && /^\d+$/.test(variant)) productUrl.searchParams.set('variant', variant);
            message = message.replace(this.dataset.productUrl, productUrl.href);
          }
          const href = 'https://wa.me/' + this.dataset.phone + '?text=' + encodeURIComponent(message);
          if (link.getAttribute('href') !== href) link.setAttribute('href', href);
        }
      }

      hasBlockingOverlay() {
        if (this.upcartOpen || document.documentElement.classList.contains('lock')) return true;
        const htmlStyle = getComputedStyle(document.documentElement);
        const bodyStyle = getComputedStyle(document.body);
        if (bodyStyle.position === 'fixed') return true;
        if (!this.ownsScrollLock && (htmlStyle.overflowY === 'hidden' || bodyStyle.overflowY === 'hidden')) return true;
        return [...document.querySelectorAll('.drawer[open], .modal[open], dialog[open], .pswp--open')].some((overlay) => overlay !== this.dialog);
      }

      openDrawer() {
        if (!this.dialog || this.dialog.open || !this.isConnected || this.hasBlockingOverlay()) return;
        this.updateLinks();
        this.dialog.showModal();
        this.ownsScrollLock = true;
        document.documentElement.classList.add('bb-contact-scroll-lock');
        this.trigger.setAttribute('aria-expanded', 'true');
        this.setTriggerHidden(true);
        this.closeButton.focus({ preventScroll: true });
        if (window.Shopify?.designMode) window.bbContactEditorSection = this.dataset.sectionId;
      }

      closeDrawer(restoreFocus = true) {
        const wasOpen = this.dialog?.open;
        if (wasOpen) this.dialog.close();
        this.finishClose(restoreFocus && wasOpen);
      }

      finishClose(restoreFocus) {
        if (this.dialog?.open) return;
        if (this.ownsScrollLock) {
          document.documentElement.classList.remove('bb-contact-scroll-lock');
          this.ownsScrollLock = false;
        }
        this.trigger?.setAttribute('aria-expanded', 'false');
        this.copySession = (this.copySession || 0) + 1;
        if (this.feedback) this.feedback.textContent = '';
        this.querySelectorAll('[data-copy-code]').forEach((button) => {
          button.disabled = false;
          button.textContent = button.dataset.originalText;
        });
        if (window.bbContactEditorSection === this.dataset.sectionId) window.bbContactEditorSection = null;
        if (this.isConnected && this.trigger) {
          this.update();
          if (restoreFocus && !this.trigger.inert) this.trigger.focus({ preventScroll: true });
        }
      }

      isBackdropClick(event) {
        if (event.target !== this.dialog) return false;
        const rect = this.dialog.getBoundingClientRect();
        return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      }

      async copyCoupon(button) {
        const code = button.dataset.copyCode;
        if (!code || button.disabled) return;
        const session = this.copySession || 0;
        button.disabled = true;
        this.feedback.textContent = '';
        try {
          if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(code);
          if (!this.isConnected || !this.dialog.open || session !== (this.copySession || 0)) return;
          button.textContent = this.dataset.copied;
          this.feedback.textContent = this.dataset.copySuccess;
        } catch {
          if (!this.isConnected || !this.dialog.open || session !== (this.copySession || 0)) return;
          this.feedback.textContent = this.dataset.copyError;
          const input = button.closest('.bb-contact__card')?.querySelector('.bb-contact__coupon-code');
          input?.focus({ preventScroll: true });
          input?.select();
        } finally {
          button.disabled = false;
        }
      }

      setTriggerHidden(hidden) {
        this.trigger.toggleAttribute('data-bb-hidden', hidden);
        this.trigger.inert = hidden;
      }

      intersects(a, b, gap = 8) {
        return b.width > 0 && b.height > 0 && a.left < b.right + gap && a.right > b.left - gap && a.top < b.bottom + gap && a.bottom > b.top - gap;
      }

      isControlVisible(control) {
        if (typeof control.checkVisibility === 'function') return control.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true, contentVisibilityAuto: true });
        const visibility = getComputedStyle(control).visibility;
        if (visibility === 'hidden' || visibility === 'collapse') return false;
        for (let element = control; element; element = element.parentElement) {
          const style = getComputedStyle(element);
          if (style.display === 'none' || parseFloat(style.opacity) === 0 || style.contentVisibility === 'hidden') return false;
        }
        return true;
      }

      update() {
        if (!this.isConnected || !this.trigger || !this.dialog) return;
        this.updateLinks();
        if (this.hasBlockingOverlay()) {
          if (this.dialog.open) this.closeDrawer(false);
          this.setTriggerHidden(true);
          return;
        }
        if (this.dialog.open) { this.setTriggerHidden(true); return; }
        const editing = document.activeElement?.matches('input:not([readonly]), textarea:not([readonly]), select, [contenteditable="true"]');
        if (editing) { this.setTriggerHidden(true); return; }
        let clearance = 0;
        const originalRect = this.trigger.getBoundingClientRect();
        for (const bar of this.bars) {
          if (!bar.classList.contains('is-visible') || getComputedStyle(bar).display === 'none') continue;
          const rect = bar.getBoundingClientRect();
          if (originalRect.left < rect.right && originalRect.right > rect.left) clearance = Math.max(clearance, bar.offsetHeight + (parseFloat(getComputedStyle(bar).bottom) || 0) + 12);
        }
        const value = Math.ceil(clearance) + 'px';
        if (this.trigger.style.getPropertyValue('--bb-clearance') !== value) this.trigger.style.setProperty('--bb-clearance', value);
        const rect = this.trigger.getBoundingClientRect();
        const viewportHeight = window.visualViewport?.height || window.innerHeight;
        const hidden = viewportHeight < 300 || rect.top < 90 || this.controls.some((control) => this.intersects(rect, control.getBoundingClientRect()) && this.isControlVisible(control));
        this.setTriggerHidden(hidden);
      }
    }
    customElements.define('bb-contact-drawer', BlocoboxContactDrawer);
  }
  } catch(e) { console.error(e); }
})();

})();
